<template>
  <Course />
</template>

<script>
import Course from "@/components/course/Course.vue";
export default {
  components: {
    Course,
  },
};
</script>
